import {
  useIonRouter,
  IonRow,
  IonCol,
  IonButton,
  IonLoading,
} from '@ionic/react'
import { ErrorMessage } from '@hookform/error-message'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import { useAccount } from '../../contexts/authContext'
import { CheckInButton } from '../../components/ui/buttons/check-in-button'
import { StyledError } from '../../components/ui/form/errors'
import { TextInput } from '../../components/ui/form/input'
import { RotateInfoContainer } from '../../rotate/components/rotate-info-container'
import { RotateInfoIntro } from '../../rotate/components/rotate-info-intro'
import { emailCheckInSchema } from '../check-in.schema'
import { useEmailCheckIn } from '../utils'
import { CheckInWrapper } from './check-in-wrapper'

import type { EmailCheckIn } from '../check-in.schema'

function EmailCheckInContent() {
  const account = useAccount()
  const checkInSettings = account.account.checkInSettings

  const router = useIonRouter()

  const { handleCheckIn, isLoading } = useEmailCheckIn({
    addCustomerRedirect: '/check-in/paired/add-customer',
    loyaltyRedirect: '/check-in/paired/loyalty-info',
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailCheckIn>({
    defaultValues: { email: '' },
    resolver: zodResolver(emailCheckInSchema),
  })

  return (
    <>
      <CheckInWrapper>
        <IonRow className="h-full">
          <IonCol size="6">
            <RotateInfoContainer>
              <IonButton
                disabled={isLoading}
                fill="solid"
                color="secondary"
                onClick={() =>
                  router.push(
                    `/check-in/paired/phone-check-in`,
                    'none',
                    'replace'
                  )
                }
              >
                Check-In With Phone
              </IonButton>
              <div className="self-center text-center">
                {checkInSettings?.body?.text ? (
                  <RotateInfoIntro>
                    {checkInSettings?.body?.text}
                  </RotateInfoIntro>
                ) : null}
              </div>
            </RotateInfoContainer>
          </IonCol>
          <IonCol
            size="6"
            className="flex h-full flex-1 flex-col items-center justify-center"
          >
            <div className="bg-ion-color-secondary w-96 rounded-2xl p-2">
              <form
                onSubmit={handleSubmit(handleCheckIn)}
                className="w-full space-y-4"
              >
                <TextInput
                  control={control}
                  name="email"
                  disabled={isLoading}
                  placeholder="Enter Your Email"
                />
                <ErrorMessage as={StyledError} name="email" errors={errors} />
                <div className="text-center">
                  <CheckInButton
                    disabled={isLoading}
                    label="Check In"
                    type="submit"
                  />
                </div>
              </form>
            </div>
          </IonCol>
        </IonRow>
      </CheckInWrapper>
      <IonLoading
        isOpen={isLoading}
        message="Hold tight, we are checking you in!"
      />
    </>
  )
}

export { EmailCheckInContent }
